<template>
  <div>
    <v-card>
      <v-card-title>Kontaktné údaje</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
            <v-text-field
              v-model="item.kontaktne_udaje_nazov"
              label="Názov"
            />
          </v-col>

          <v-col
            cols="12"
            sm="6"
          >
            <v-text-field
              v-model="item.kontaktne_udaje_adresa"
              label="Adresa"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="item.kontaktne_udaje_telefon"
              label="Telefónny kontakt"
            />
          </v-col>

          <v-col
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="item.kontaktne_udaje_email"
              label="Email"
            />
          </v-col>
          <v-col
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="item.kontaktne_udaje_web"
              label="Web"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="my-3">
      <v-card-title>Kontaktná osoba</v-card-title>
      <v-card-text>

        <v-row>
          <v-col
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="item.kontaktna_osoba_meno"
              label="Meno a priezvisko"
            />
          </v-col>

          <v-col
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="item.kontaktna_osoba_email"
              label="Email"
            />
          </v-col>
          <v-col
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="item.kontaktna_osoba_telefon"
              label="Telefónny kontakt"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="my-3">
      <v-card-title>Informácie o SP</v-card-title>
      <v-card-text>

        <v-row>
          <v-col>
            <v-textarea
              v-model="item.zakladne_informacie"
              label="Základné informácie"
              auto-grow
              rows="1"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="item.miesto_cinnosti_a_aktivit"
              label="Miesto činnosti a aktivít"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              v-model="item.sluzby"
              label="Služby pre znevýhodnené a zraniteľné osoby  (pridaná hodnota)"
              auto-grow
              rows="1"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              v-model="item.navrhovane_pracovne_pozicie"
              label="Navrhované pracovné pozície"
              auto-grow
              rows="1"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              v-model="item.pracovna_cinnost"
              label="Pracovná činnosť zamestnancov "
              auto-grow
              rows="1"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              v-model="item.predpoklady_prijatia"
              label="Predpoklady prijatia"
              auto-grow
              rows="1"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              v-model="item.ine"
              label="Iné"
              auto-grow
              rows="1"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h3>Poskytované služby</h3>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-checkbox
              v-model="item.ubytovanie"
              label="Ubytovanie"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="item.doprava"
              label="Doprava"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="item.financne_zalohy"
              label="Finančné zálohy"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="item.mentoring"
              label="Mentoring"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="item.rekvalifikacia"
              label="Rekvalifikácia"
            ></v-checkbox>
          </v-col>

        </v-row>
      </v-card-text>
    </v-card>
    <v-row v-if="editable">
      <v-col>
        <v-spacer />
        <v-btn
          color="primary"
          class="ma-5"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import { APIService } from "@/http/APIService.js";
const apiService = new APIService();


export default {
  name: "SocialnyPodnikProfile",
  props: {
    item: { required: true, type: Object },
    editable: { type: Boolean, default: false }
  },

  data() {
    return {
    };
  },

  computed: {
  },

  methods: {
    updateItem() {
      apiService.updateSocialnyPodnikUser(this.item).then((response) => {
        this.item = response;
      });
    }
  }
};
</script>